import { useState, useEffect } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const BRING_NOTIFICATIONS_TO_MW_TEST_NAME = 'bringNotificationstoMw_Jan2026';
const IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME = 'improveNotificationExperience_Feb2026';

export const useMwNotificationsVariant = (): boolean | null => {
    const [isMwNotificationsClientVariant, setIsMwNotificationsClientVariant] = useState(false);

    useEffect(() => {
        const isVariant = getAbTestV2(BRING_NOTIFICATIONS_TO_MW_TEST_NAME)?.variant === 'variant';
        setIsMwNotificationsClientVariant(isVariant);
    }, []);

    return isMwNotificationsClientVariant;
};

export const isMwNotificationsVariant = (): boolean => {
    return getAbTestV2(BRING_NOTIFICATIONS_TO_MW_TEST_NAME)?.variant === 'variant';
};

export const trackMwNotificationsVariant = (): void => {
    trackAbTestV2Variant(BRING_NOTIFICATIONS_TO_MW_TEST_NAME);
};

export const useUpdatedNotificationContentVariant = (): boolean => {
    const [isUpdatedNotificationContentVariant, setIsUpdatedNotificationContentVariant] =
        useState(false);

    useEffect(() => {
        const isVariant =
            getAbTestV2(IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME)?.variant === 'variant';
        setIsUpdatedNotificationContentVariant(isVariant);
    }, []);

    return isUpdatedNotificationContentVariant;
};

export const isUpdatedNotificationContentVariant = (): boolean => {
    return getAbTestV2(IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME)?.variant === 'variant';
};

export const trackUpdatedNotificationContentVariant = (): void => {
    trackAbTestV2Variant(IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME);
};
